<!-- <app-membership-restriction *ngIf="!isLoggedIn"></app-membership-restriction> -->
<div class="flex flex-col justify-center items-center">
    <button (click)="startRecognition()" class="p-2 border bg-gray-400 w-[50%] mb-3">Start Recognition</button>
    <!-- <button (click)="stopRecognition()">Stop Recognition</button> -->
    <textarea [value]="transcript" rows="10" cols="50" readonly class="border w-[60%]"></textarea>
  </div>
  